<template>
    <transition
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div
            v-if="visible"
            ref="wrapperRef"
            tabindex="-1"
            class="fixed top-0 left-0 w-full h-full duration-300 ease-in-out cursor-auto bg-color-neutral-black z-overlay-canvas-modal"
            :data-component="$options.name"
            @keyup.esc="close"
        >
            <button
                type="button"
                :aria-label="AriaLabel.CLOSE"
                class="absolute top-16 left-16 flex items-center gap-8 font-bold text-text-l text-color-neutral-white hover:underline"
                @click="close"
            >
                <ms-close class="w-24 h-24" /> schließen
            </button>
            <slot name="content" />
        </div>
    </transition>
</template>
<script lang="ts" src="./MsLightbox.ts" />
